/* tslint:disable */

/**
 */
export class ActivityArr {
    activity_arr?: string;
}
